module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-25-d9e12509717ec54819322e88aacb3b97.svg";